import Vue from 'vue'
import App from './App.vue'
import router from './router'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import './less/common.less'
// import './less/reset.less'
// import './less/mintui.less'
// import Vconsole from 'vconsole'
// import wx from 'weixin-js-sdk'
// new Vconsole()
Vue.config.productionTip = false
import MetaInfo from 'vue-meta-info'
Vue.use(MintUI)
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(MetaInfo)
Vue.use(Vant)

/**
 * 日期格式换算 YYYY-MM-DD hh:mm:ss => YYYY/MM/DD
 */

Vue.filter('dateFormat', function(time) {
  if (time) {
    return time.split(' ')[0].replace(/-/g, '/')
  }
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
